import { render } from "./TheLoaiDiTichVH.vue?vue&type=template&id=d5e2e628"
import script from "./TheLoaiDiTichVH.vue?vue&type=script&lang=js"
export * from "./TheLoaiDiTichVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__